import React from 'react';
import AdminFAQComponent from '../../components/admin/AdminFAQ';

const AdminFAQ = () => {
  return <AdminFAQComponent />;
};

export default AdminFAQ;
